<div fxLayout="column" class="panel-background">
  <div
    fxLayout="row-wrap"
    fxLayoutAlign="start center"
    fxLayoutGap="2rem"
    fxLayout.lt-lg="column"
    fxLayoutAlign.lt-lg="initial"
    fxLayoutGap.lt-lg="0.5rem"
    class="p-1"
  >
    <ng-content select="[actionsLeft]"></ng-content>
    <ng-content fxFlex="auto" select="[actionsCenter]"></ng-content>
    <ng-content select="[actionsRight]"></ng-content>
  </div>
  <div style="overflow-y: auto; flex: 1">
    <ng-content select="[content]"></ng-content>
  </div>
  <ng-content select="[footer]"></ng-content>
</div>
